import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { company } from '~/company/Company';
import { carouselProps } from '~/components/CategoryBlocks/ProductsCarouselSliderOneBlock/config';
import { CommonCarousel } from '~/components/CommonCarousel';
import { ModalType } from '~/components/Modal/interface';
import ProductCard from '~/components/ProductCard/ProductCard';
import Section from '~/components/Section';
import { useGlobal } from '~/hooks/useGlobal';
import { useModal } from '~/hooks/useModal';
import { CategorySkeleton } from '~/pages/Catalog/CatalogSkeleton';

import { catalogStore, userStore } from '~/stores';

import { CAROUSEL_MAX_ITEMS, RECOMMENDATION_TITLES } from './constants';
import { CarouselContainerProps } from './interfaces';
import styles from './Recommendations.module.scss';

// TODO: use later on next iteration
export const LinkToComponent = ({
  source,
}: Pick<CarouselContainerProps, 'source'>) => {
  const { openModal } = useModal();
  const [, setSearchParams] = useSearchParams();
  const { t } = useTranslation();

  const handleOpenAll = () => {
    const searchParams = openModal(ModalType.Recommendations);
    searchParams.set('source', source.toString());
    setSearchParams(searchParams);
  };

  return (
    <span
      role="button"
      aria-label={t('viewAll')}
      className={styles.linkToButton}
      onClick={handleOpenAll}
    >
      {t('viewAll')}
    </span>
  );
};

const Recommendations = ({
  className,
  source,
  max = CAROUSEL_MAX_ITEMS,
}: CarouselContainerProps) => {
  const { t } = useTranslation();
  const { isMobile } = useGlobal();

  if (catalogStore.productRecommendationsMeta.isLoading) {
    return (
      <div className={styles.skeletonContainer}>
        <CategorySkeleton num={isMobile ? 2 : 5} />
      </div>
    );
  }

  const products = catalogStore.productRecommendations[source];

  if (!products || !products.data.length) {
    return null;
  }

  const sectionTitle = RECOMMENDATION_TITLES[source] || 'recommended';
  return (
    <Section
      className={classes([styles.root, className])}
      title={t(sectionTitle)}
    >
      <CommonCarousel
        {...carouselProps[company.name]}
        slideClassName={styles.slide}
        sliderClassName={styles.carousel}
        slideVariant="white"
        slidesPerViewProp={isMobile ? 2 : 5}
        pagination={{
          enabled: false,
        }}
        dir={userStore.dir}
        key={userStore.dir}
      >
        {products.data.slice(0, max).map((product) => (
          <ProductCard
            product={product}
            className={styles.slideProduct}
            key={product.id}
          />
        ))}
      </CommonCarousel>
    </Section>
  );
};

export default observer(Recommendations);
